module.exports = __webpack_public_path__ + "img/protective_gear5.398918d8.png";